/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { EMPTY_ARRAY } from 'constants/frozenObjects'

export const getAlerts = state => state.alerts.items || EMPTY_ARRAY
